
export const koTranslations = {
  'nav.home': '홈',
  'nav.products': 'eSIM',
  'nav.contact': '문의',
  'product.customize': '커스터마이즈',
  'product.price_oriented': '가격 우선',
  'product.quality_oriented': '품질 우선',
  'product.specs': '사양',
  'product.usage_days': '사용 일수',
  'product.day': '일',
  'product.gb_per_day': '일일 GB',
  'product.unlimited': '무제한',
  'checkout.title': '결제',
  'checkout.email': '이메일',
  'checkout.card_info': '카드 정보',
  'checkout.card_number': '카드 번호',
  'checkout.expiry_date': '유효기간',
  'checkout.cvc': '보안코드',
  'checkout.pay': '지금 결제',
  'checkout.total': '총액',
  'checkout.tax': '세금 포함',
  'checkout.terms': '서비스 약관에 동의합니다',
  'footer.privacy': '개인정보처리방침',
  'footer.terms': '서비스 이용약관',
  'footer.company': '회사 소개',
  'footer.law': '특정상거래법',
  'footer.copyright_tomaruyo': '© {year} TomaRuyo 모든 권리 보유.',
  // New translations
  'hero.title': '일본에서 사용하는 저렴한 eSIM',
  'hero.subtitle': '편안한 숙박과 원활한 인터넷 연결을 즐기세요. 저희 오리지널 eSIM으로 여행의 추억을 공유하세요.',
  'hero.apa.title': '일본에서 사용하는 저렴한 eSIM을 받으세요',
  'hero.apa.subtitle': '편안한 숙박과 원활한 인터넷 연결을 즐기세요. APA 호텔의 오리지널 데이터 플랜으로 비즈니스와 레저를 더욱 편리하게.',
  'products.title': 'eSIM 플랜',
  'products.subtitle': '원하는 통신 플랜을 선택할 수 있습니다. 가격 중심의 경제적인 플랜부터 고품질 통신 환경을 제공하는 프리미엄 플랜까지 모두 제공합니다.',
  'products.all': '전체',
  'products.price_focus': '가격 중심',
  'products.quality': '품질 중심',
  'products.choose_plan': '이 플랜 선택',
  'products.selected': '선택됨',
  'customization.days': '일',
  'customization.back': '돌아가기',
  'checkout.payment_info': '결제 정보',
  'checkout.secure_payment': 'Stripe을 통한 안전한 결제',
  'checkout.order_summary': '주문 요약',
  'checkout.plan': '플랜:',
  'checkout.data_amount': '데이터:',
  'checkout.network': '네트워크:',
  'checkout.usage_days': '사용 일수:',
  'checkout.base_fee': '기본 요금:',
  'checkout.days_fee': '일일 요금:',
  'checkout.processing': '처리 중...',
  'checkout.privacy_policy': '개인정보처리방침',
  'checkout.agree': '동의합니다',
  'thankyou.title': '주문해 주셔서 감사합니다!',
  'thankyou.message': '{email}로 확인 이메일을 보냈습니다. 24시간 이내에 eSIM 정보를 받으실 수 있습니다.',
  'thankyou.next_steps': '다음 단계',
  'thankyou.step1': '1. 이메일 확인',
  'thankyou.step2': '2. 주문 확인 이메일을 받으실 것입니다',
  'thankyou.step3': '3. eSIM 정보는 24시간 이내에 전송됩니다',
  'thankyou.back_to_home': '홈으로 돌아가기',
  'thankyou.official_site': 'Super Hotel 공식 사이트로 이동',
  'thankyou.rb_official_site': 'R&B Hotel 공식 사이트로 이동',
  'thankyou.apa_official_site': 'APA Hotel 공식 사이트로 이동',
  'footer.links': '링크',
  'footer.official_website': '공식 웹사이트',
  'footer.hotel_list': '호텔 목록',
  'footer.campaigns': '캠페인',
  'footer.stay_plans': '숙박 플랜',
  'footer.information': '정보',
  'footer.copyright': '© {year} Super Hotel Co., Ltd. 모든 권리 보유.',
  'footer.rb_copyright': '© {year} R&B Hotel. 모든 권리 보유.',
  'footer.apa_copyright': '© {year} APA HOTEL Co., Ltd. 모든 권리 보유.',
  'hero.choose_esim': 'eSIM 선택',
  'hero.learn_more': '자세히 보기',
  
  // New translations for the updated eSIM Direct page
  'products.short_stay': '단기 체류 플랜',
  'products.long_stay': '장기 체류 플랜',
  'products.days': '일수',
  'products.data': '데이터량',
  'products.price_label': '가격',
  'products.after_data': '데이터 소진 후',
  'products.action': '액션',
  'products.days_suffix': '일',
  'products.data_filter': '데이터량별 필터',
  'products.days_filter': '체류 기간별 필터',
  'products.all_data': '모든 데이터량',
  'products.all_days': '모든 체류 기간',
  'products.tax': '세금',
  'products.no_products': '조건에 맞는 플랜이 없습니다',
  'products.coming_soon': '곧 출시예정...',
  'products.premium_coming_soon': '프리미엄 플랜 곧 출시',
  'products.available': '이용 가능한 eSIM 플랜',
  'checkout.after_data': '데이터 소진 후',
  'checkout.delivery': '배송',
  'checkout.express_delivery': '30분 이내 이메일 발송',
  'thankyou.choice_official_site': 'Choice Hotels Japan 공식 사이트로 이동',
  'hero.choice.title': '일본에서 사용하는 저렴한 eSIM',
  'hero.choice.subtitle': '편안한 숙박과 원활한 인터넷 연결을 즐기세요. Choice Hotels Japan의 오리지널 데이터 플랜으로 비즈니스와 레저를 더욱 편리하게.',
  'hero.rembrandt.title': '일본에서 사용하는 저렴한 eSIM',
  'hero.rembrandt.subtitle': '편안한 숙박과 원활한 인터넷 연결을 즐기세요. Rembrandt Hotel의 오리지널 데이터 플랜으로 비즈니스와 레저를 더욱 편리하게.',
  'thankyou.rembrandt_official_site': 'Rembrandt Hotel 공식 사이트로 이동',
  'footer.choice_copyright': '© {year} Choice Hotels Japan. 모든 권리 보유.',
  'footer.rembrandt_copyright': '© {year} Rembrandt Group. 모든 권리 보유.',
  'checkout.express_fee': '특급 배송비:',
  
  // Add new translations
  'checkout.tax_included': '(세금 포함)',
  'products.standard_1day': '스탠다드 1일 플랜',
  'products.standard_3days': '스탠다드 3일 플랜',
  'products.standard_7days': '스탠다드 7일 플랜',
  'products.standard_15days': '스탠다드 15일 플랜',
  'products.standard_30days': '스탠다드 30일 플랜',
  'products.standard_60days': '스탠다드 60일 플랜',
  'products.standard_90days': '스탠다드 90일 플랜',
  'products.premium_1day': '프리미엄 1일 플랜',
  'products.premium_3days': '프리미엄 3일 플랜',
  'products.premium_7days': '프리미엄 7일 플랜',
  'products.premium_15days': '프리미엄 15일 플랜',
  'products.premium_30days': '프리미엄 30일 플랜',
  'products.premium_60days': '프리미엄 60일 플랜',
  'products.premium_90days': '프리미엄 90일 플랜',
  'products.after_data_standard_1day': '속도 128kbps로 제한',
  'products.after_data_standard_3days': '속도 128kbps로 제한',
  'products.after_data_standard_7days': '속도 128kbps로 제한',
  'products.after_data_standard_15days': '속도 128kbps로 제한',
  'products.after_data_standard_30days': '속도 128kbps로 제한',
  'products.after_data_standard_60days': '속도 128kbps로 제한',
  'products.after_data_standard_90days': '속도 128kbps로 제한',
  'products.after_data_premium_1day': '속도 1Mbps로 제한',
  'products.after_data_premium_3days': '속도 1Mbps로 제한',
  'products.after_data_premium_7days': '속도 1Mbps로 제한',
  'products.after_data_premium_15days': '속도 1Mbps로 제한',
  'products.after_data_premium_30days': '속도 1Mbps로 제한',
  'products.after_data_premium_60days': '속도 1Mbps로 제한',
  'products.after_data_premium_90days': '속도 1Mbps로 제한',
  
  // Add new translations for express delivery
  'checkout.express_delivery_message': '특급 서비스: 30분 이내에 이메일로 eSIM을 전송해드립니다',
  'checkout.standard_delivery_message': '24시간 이내에 이메일로 eSIM을 전송해드립니다',
  'checkout.express_delivery_option': '30분 이내 eSIM 수신 (+¥550)',
  
  // Add translations for customer info section
  'checkout.customer_info': '고객 정보',
  'checkout.basic_info': '기본 정보',
  'checkout.additional_info': '추가 정보 (선택사항)',
  'checkout.name': '이름',
  'checkout.name_placeholder': '예: 김철수',
  'checkout.phone': '전화번호',
  'checkout.phone_placeholder': '예: 09012345678',
  'checkout.country': '국적/거주국',
  'checkout.country_placeholder': '국가를 선택해 주세요',
  'checkout.device_info': '기기 정보',
  'checkout.device_info_placeholder': '기기를 선택해 주세요',
  'checkout.travel_purpose': '여행 목적',
  'checkout.travel_purpose_placeholder': '목적을 선택해 주세요',
  'checkout.marketing_consent': '고객 지원, 캠페인 및 프로모션 정보를 이메일로 받는 것에 동의합니다',
  'checkout.support_info': '고객 지원 목적으로 사용됩니다.',
  
  // Payment button translations
  'checkout.complete_payment': '결제 완료',
  'checkout.back': '돌아가기',
  'checkout.tourism': '관광',
  'checkout.business': '비즈니스',
  'checkout.family': '가족 방문',
  'checkout.education': '유학/교육',
  'checkout.other': '기타',
  
  // Add new translations for checkout section
  'checkout.proceed_to_order': '주문하기',
  'checkout.selected_product': '선택한 상품',
  'checkout.price': '가격',
  'checkout.proceed_to_checkout': '결제 진행',
  'checkout.select_product': '상품을 선택해 주세요',
  
  // Add missing proceed to payment key
  'checkout.proceed_to_payment': '결제하기',
  
  // Add new UI element translations
  'checkout.payment': '결제 정보',
  'checkout.cardholder_name': '카드 소유자 이름',
  'checkout.reload_form': '폼 새로고침',
  'admin.confirm_purchase': '구매 확인',
  'admin.update_data': '데이터 업데이트',
  
  // Loading translations
  'products.loading': '로딩 중...',
  'error.title': '오류가 발생했습니다',
  'error.try_again_later': '잠시 후 다시 시도해 주세요',
  'error.retry': '다시 시도',
};
